import { CURRENT_WEEK } from "@/router";

function readInitializeData() {
  if (typeof document === "undefined") {
    return {};
  }

  const el = document.getElementById("_vue-initialize-data");
  if (!el || !el.textContent) {
    return {};
  }

  try {
    return JSON.parse(el.textContent);
  } catch (error) {
    return {};
  }
}

const initializeData = readInitializeData();

export function normalizeTopicSlug(slug) {
  return typeof slug === "string" ? slug.replace(/^topic-/, "") : slug;
}

export function getCurrentTopicSlug(routeParams = {}) {
  if (routeParams.week) {
    return normalizeTopicSlug(routeParams.week);
  }

  if (initializeData.slug) {
    return normalizeTopicSlug(initializeData.slug);
  }

  if (routeParams.year) {
    return `week${routeParams.year}`;
  }

  return CURRENT_WEEK;
}

export default initializeData;
